import { render } from "./PersonaCard.vue?vue&type=template&id=e380e6f8&scoped=true"
import script from "./PersonaCard.vue?vue&type=script&lang=js"
export * from "./PersonaCard.vue?vue&type=script&lang=js"

import "./PersonaCard.vue?vue&type=style&index=0&id=e380e6f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e380e6f8"]])

export default __exports__